<template>
  <div class="proa-list-group-item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ProaListGroupItem',
  props: {
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.proa-list-group-item {
  padding: 17px 10px;
  border-bottom: 1px solid $light-border-color;

  @include mq(md) {
    padding: 20px 23px;
  }
}
</style>
